import {actionTypes} from '../const';
const initialState = {
    showModal : false,
    modalName:'',
    changesInActivity:false,
    activityErr:false,
    activityErrPopup:false,
    action:'',
    latestRecords:true,
    activityModalToggleState: false,
    activityModalkey: 1,
    activityModalIsEdit: false,
    deadheadWarning:false,
    deadheadMessage:'',
    workday_id_manual:0
}

const modals = (state = initialState, action) => {
    var certifyModal = false;
    switch (action.type) {
        
        case actionTypes.SHOWMODAL_SUCCESS:
            if(action.modalName == 'Certify_Modal'){
                certifyModal = true;
            }
            return Object.assign({}, state, {
                showModal : action.showModal,
                modalName:action.modalName,
                action:action.action,
                workdayId:action.workdayId
            });
        case actionTypes.HIDEMODAL_SUCCESS:
            return Object.assign({}, state, {
                showModal : action.showModal,
                modalName:'',
                changesInActivity: false
            });
        case actionTypes.CHANGES_SUCCESS:
            return Object.assign({}, state, {
                changesInActivity:action.changesInActivity
            });
        case actionTypes.ACTIVITY_ERR_SUCCESS:
            return Object.assign({}, state, {
                activityErrPopup:action.activityErrPopup,
                activityErr:action.activityErr,
                activityErrMessage:action.activityErrMessage,
                latestRecords:action.latestRecords,
                certifyError: action.certifyError
        });
        case actionTypes.ACTIVITY_EDIT_SUCCESS:
            return Object.assign({}, state, {
                activityModalIsEdit:true
            })
        case actionTypes.DEADEHEAD_WARNING:
            return Object.assign({}, state, {
                deadheadWarning:action.warning,
                deadheadMessage:action.warningMessage
            })
        case actionTypes.SHOWMODAL_MANUAL:
            return Object.assign({}, state, {
                workday_id_manual : action.id_manual
            });
        default:
            return state;
    }
}
export default modals